import { ON_SATISFACTION_RECEIVED_EVENT_TYPE } from 'core/constants';
import { createSatisfactionCallbackResponse } from 'core_main/api/satisfaction/helpers';
import { runListenersForEvent } from 'core_main/globals/events';
import Pubnub from 'pubnub';
import { PubNubCsatSendMessageEvent } from '../types';

export const handleChatCsatSendEvent = (
  message: PubNubCsatSendMessageEvent,
  timetoken: Pubnub.MessageEvent['timetoken'],
) => {
  const { included } = message;

  const form = included?.find((entity) => entity.type === 'satisfaction');

  const callbackResponse = createSatisfactionCallbackResponse(
    message.data,
    timetoken,
    form,
  );

  runListenersForEvent(ON_SATISFACTION_RECEIVED_EVENT_TYPE, callbackResponse);
};
